// SIM NATION — makes a parent nav item's own link (e.g. "SHOP") navigate
// when its text/word is clicked, while the caret/arrow still opens the
// dropdown.
(function(){
  // Inject styling so the swapped-in <a> looks identical to the plain
  // text it replaced (no underline, inherits color/font/size).
  var style = document.createElement('style');
  style.textContent = '.sng-nav-text-link{text-decoration:none!important;color:inherit!important;font:inherit!important;cursor:pointer;}.sng-nav-text-link:hover,.sng-nav-text-link:visited,.sng-nav-text-link:active{text-decoration:none!important;color:inherit!important;}';
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function(){
    var summaries = document.querySelectorAll('.navbar-nav.header__nav-list > li.nav-item > header-menu-trigger > details > summary.parent-menu__link');
    summaries.forEach(function(summary){
      var textSpan = summary.querySelector('.menu-main-link');
      if(!textSpan) return;
      var linkUrl = summary.getAttribute('data-nav-url');
      if(!linkUrl) return;

      var textNode = null;
      textSpan.childNodes.forEach(function(node){
        if(node.nodeType === Node.TEXT_NODE && node.textContent.trim().length){
          textNode = node;
        }
      });
      if(!textNode) return;

      var a = document.createElement('a');
      a.href = linkUrl;
      a.className = 'sng-nav-text-link';
      a.textContent = textNode.textContent;
      a.addEventListener('click', function(e){
        e.stopPropagation();
      });
      textNode.parentNode.replaceChild(a, textNode);
    });
  });
})();
